import { fetcher } from '@commenda/utils';
import {
  CreateExemptionCertificate,
  CreateJurisdictionExemption,
  ExemptionCertificateFileUploadPayload,
  ExemptionCertificateFileUploadResponse,
  ExemptionCertificateResponse,
  JurisdictionExemptionResponse,
} from './types';

export async function createExemptionCertificate(
  body: CreateExemptionCertificate
): Promise<{
  success: boolean;
  data?: ExemptionCertificateResponse;
  error?: string;
}> {
  try {
    const response = await fetcher(
      'new-sales-tax/exemption-certificates',
      {
        method: 'POST',
        body,
      },
      undefined
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to create exemption certificate',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}

export async function createJurisdictionExemption(
  certificateId: string,
  body: CreateJurisdictionExemption
): Promise<{
  success: boolean;
  data?: JurisdictionExemptionResponse;
  error?: string;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/exemption-certificates/${certificateId}/jurisdictions`,
      {
        method: 'POST',
        body,
      },
      undefined
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to create jurisdiction exemption',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}

export async function uploadExemptionCertificateFile(
  uploadData: ExemptionCertificateFileUploadPayload
): Promise<{
  success: boolean;
  data?: ExemptionCertificateFileUploadResponse;
  error?: string;
}> {
  try {
    const response = await fetcher(
      'new-sales-tax/exemption-certificates/file',
      {
        method: 'POST',
        body: uploadData,
      },
      undefined
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to upload exemption certificate file',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}
